import React from 'react';
import WidgetMyActiveExchangesViewPanel from './view';
import DetailPanel from './../../../core/detail';
import ExchangeService from './../../../../../service/exchange';
import mapStateToProps from './../../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../../store/map/on-logout';
import { connect } from 'react-redux';

class _WidgetMyActiveExchangesPanel extends DetailPanel 
{
    constructor(parms)
    {
        super(parms);

        this.getLoadedDataDetailUi = this.getLoadedDataDetailUi.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.loadData = this.loadData.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.state = this.getDefaultState();
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    loadData(inputObj)
    {
        super.loadData(inputObj);
        ExchangeService.searchActive({
            request: {
                page: inputObj.page,
                text: inputObj.text,
            },
            onResponse: this.onLoadDataResponse,
            onError: this.onLoadDataError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    componentDidMount()
    {
        this.loadData({ page: 0, text: '' });
    }

    getLoadedDataDetailUi()
    {
        return <WidgetMyActiveExchangesViewPanel data={this.state.data} />
    }
}

const WidgetMyActiveExchangesPanel = connect(mapStateToProps, mapDispatchToProps)(_WidgetMyActiveExchangesPanel);
export default WidgetMyActiveExchangesPanel;
